// extracted by mini-css-extract-plugin
module.exports = {"balloon":"a10a3f92e9--balloon--P880_","icon":"a10a3f92e9--icon--Lo6q4","route":"a10a3f92e9--route--AZBYg","route-button":"a10a3f92e9--route-button--jfUcZ"};